/*
 * 空蔵 / KURA landing-page interactions.
 *  - FAQ accordion (.kura-faq__item)               → click to expand/collapse
 *  - Beyond-rice / voice sliders (.kura-slider)     → prev / next arrows
 *  - Product color swatches (.kura-prod__swatches)  → highlight selected color
 * Idempotent; re-scans on Shopify section load in the theme editor.
 */
(function () {
  function initAccordions(root) {
    root.querySelectorAll('.kura-faq__item').forEach((item) => {
      if (item.dataset.kuraBound) return;
      item.dataset.kuraBound = '1';
      const trigger = item.querySelector('.kura-faq__q');
      const panel = item.querySelector('.kura-faq__a');
      if (!trigger || !panel) return;

      const close = () => {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.style.maxHeight = '0px';
      };
      const open = () => {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      };

      close();
      trigger.addEventListener('click', () => {
        if (item.classList.contains('is-open')) {
          close();
        } else {
          open();
        }
      });
      // keep height accurate after resize
      window.addEventListener('resize', () => {
        if (item.classList.contains('is-open')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  function initSliders(root) {
    root.querySelectorAll('.kura-slider').forEach((slider) => {
      if (slider.dataset.kuraBound) return;
      slider.dataset.kuraBound = '1';
      const track = slider.querySelector('.kura-slider__track');
      if (!track || track.children.length === 0) return;
      const prev = slider.querySelector('[data-kura-prev]');
      const next = slider.querySelector('[data-kura-next]');
      const viewport = slider.querySelector('.kura-slider__viewport');
      const peek = slider.dataset.kuraPeek === 'true';
      const infinite = slider.dataset.kuraInfinite === 'true';

      if (peek && infinite && viewport) {
        initInfinitePeek(track, viewport, prev, next);
      } else {
        initSimpleSlider(track, prev, next, slider.dataset.kuraLoop === 'true');
      }
    });
  }

  /*
   * Seamless infinite peek carousel — manual arrows only, NO autoplay.
   * Clones the whole set on both sides so the centred slide can advance
   * forever; when a click lands on a clone, jump (no transition) to the
   * matching real slide once the animation ends.
   */
  function initInfinitePeek(track, viewport, prev, next) {
    const originals = Array.from(track.children);
    const n = originals.length;
    const TRANS = 'transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)';

    const centerOffset = (s) => s.offsetLeft - (viewport.clientWidth - s.offsetWidth) / 2;

    if (n === 1) {
      const only = originals[0];
      only.classList.add('is-active');
      const c = () => { track.style.transform = 'translateX(' + -centerOffset(only) + 'px)'; };
      window.addEventListener('resize', c);
      requestAnimationFrame(c);
      return;
    }

    // append clones after, prepend clones before (both in original order)
    originals.forEach((s) => {
      const c = s.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c);
    });
    originals.slice().reverse().forEach((s) => {
      const c = s.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.insertBefore(c, track.firstChild);
    });

    const slides = Array.from(track.children); // 3n: [pre][real][post]
    let index = n; // first real slide
    let animating = false;

    const center = (i, animate) => {
      track.style.transition = animate ? TRANS : 'none';
      track.style.transform = 'translateX(' + -centerOffset(slides[i]) + 'px)';
      slides.forEach((sl, k) => sl.classList.toggle('is-active', k === i));
    };

    track.addEventListener('transitionend', (e) => {
      if (e.propertyName !== 'transform') return;
      if (index < n) { index += n; center(index, false); }
      else if (index >= 2 * n) { index -= n; center(index, false); }
      animating = false;
    });

    const go = (dir) => {
      if (animating) return;
      animating = true;
      index += dir;
      center(index, true);
    };

    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));
    window.addEventListener('resize', () => center(index, false));
    requestAnimationFrame(() => center(index, false));
  }

  /* Simple 100%-width slider (e.g. Voice) — arrows, optional wrap. */
  function initSimpleSlider(track, prev, next, loop) {
    const slides = Array.from(track.children);
    let index = 0;
    const clamp = (m) => (loop ? (m + slides.length) % slides.length : Math.max(0, Math.min(m, slides.length - 1)));
    const go = (m) => {
      index = clamp(m);
      track.style.transform = 'translateX(' + -index * 100 + '%)';
      if (!loop) {
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
      }
      slides.forEach((sl, i) => sl.classList.toggle('is-active', i === index));
    };
    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));
    go(0);
  }

  function initSwatches(root) {
    root.querySelectorAll('.kura-prod__swatches').forEach((group) => {
      if (group.dataset.kuraBound) return;
      group.dataset.kuraBound = '1';
      const swatches = Array.from(group.querySelectorAll('.kura-prod__swatch'));
      swatches.forEach((sw) => {
        sw.addEventListener('click', () => {
          swatches.forEach((s) => s.classList.remove('is-active'));
          sw.classList.add('is-active');
        });
      });
    });
  }

  function init(root) {
    const scope = root || document;
    initAccordions(scope);
    initSliders(scope);
    initSwatches(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  }
})();
